module.exports = __webpack_public_path__ + "static/media/robot walking.e6e116ce.gif";